define(function (require) {
    require("@modules/tools/ko.async");
    require("@modules/tools/ko.extensions");

    var ko = require("knockout");
    var $ = require("jquery");
    var _ = require("underscore");
    var FacilityResultViewModel = require("@modules/tools/facilityResultViewModel");
    var PharmacyResultViewModel = require("@modules/tools/pharmacy-search/pharmacyResultViewModel");
    var urlParameters = require("@modules/tools/urlParameters");
    var geocoder = require("@modules/tools/geocoder");
    var queryString = require("querystring");
    var utility = require("@modules/tools/helpfulToolUtility");
    var getPropertyCaseInsensitive = require("@modules/insensitiveProperty");
    var whitelistUrlService = require("@modules/tools/whitelistUrlService");
    var scanTranslations = require("scanTranslations");

    // PharmacySearchViewModel ctor
    return function (gtmDataLayerPush) {
        var self = this;
        var focusedElement;

        var defaultPlanName = window.scan.pharmacyDefaultPlanName;

        // If any of the arrays below start with an item
        // helpfulToolUtility.filtersHaveNonDefaultValues will need updated
        var defaultParameters = {
            zipOrAddress: "",
            radius: "5",
            pageNumber: 1,
            year: window.scan.aepYears[window.scan.aepYears.length - 1],
            sort: "distance",
            planSelectedName: defaultPlanName
        };

        var dataLayer = window.dataLayer || [];
        var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
        dataLayer.push({
            event: "gaPageview",
            eventCategory: "Pageview",
            eventAction: url,
            eventLabel: "Pharmacies Search"
        });
        var usedNonDefaultParams = false;
        var initialLoad = true;
        var pageSize = window.scan.resultPageSize > 0 ? window.scan.resultPageSize : 20;
        var tempResults = [];

        self.currentSearchParameters = ko.observable();
        self.pharmacyService = require("@modules/tools/pharmacy-search/pharmacyService");

        // various flags/state properties
        self.initialLoad = ko.pureComputed(function () {
            return initialLoad;
        });
        self.isSearchStarted = ko.observable(false);
        self.pageSize = ko.observable(pageSize);
        self.contextItemId = ko.observable(window.scan.contextItemId);
        self.pageNumber = ko.observable(1);
        self.fatalError = ko.observable(false);
        self.detailId = ko.observable();
        self.isLeavingForDetailPage = ko.observable(false);
        self.hasSearchRun = ko.observable(false);
        let isSystemResettingFilters = false;

        // api service
        const urlParams = urlParameters.read();
        const returnUrl = getPropertyCaseInsensitive(urlParams, "return_url");
        const path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));

        self.isDrx = ko.observable(false);
        self.selectPcp = ko.observable(false);

        if (returnUrl) {
            whitelistUrlService
                .validateUrl(returnUrl)
                .done(function (data) {
                    self.isDrx(true);
                })
                .fail(function (jqXHR) {
                    console.log(jqXHR.responseJSON.Message);
                });
        }

        if (urlParams.year) {
            urlParams.year = parseInt(urlParams.year, 10); // make the year a number if set in url
        }
        // arrayify urlParams that are arrays in the model
        if (urlParams.pharmacyTypes && !$.isArray(urlParams.pharmacyTypes)) {
            urlParams.pharmacyTypes = [urlParams.pharmacyTypes];
        }

        // arrayify urlParams that are arrays in the model
        if (urlParams.languages && !$.isArray(urlParams.languages)) {
            urlParams.languages = [urlParams.languages];
        }

        if (urlParams.planState && !$.isArray(urlParams.planState)) {
            urlParams.planState = urlParams.planState;
        }

        if (urlParams.planSelectedName && !$.isArray(urlParams.planSelectedName)) {
            urlParams.planSelectedName = urlParams.planSelectedName;
        }

        // form field values
        self.sort = ko.observable().extend({ defaultOnNull: defaultParameters.sort });
        self.zipOrAddress = ko.observable();
        self.radius = ko.observable().extend({ defaultOnNull: defaultParameters.radius });
        self.name = ko.observable();
        self.year = ko.observable().extend({ defaultOnNull: defaultParameters.year });

        self.preferredPharmacies = ko.observable();
        self.open24Hours = ko.observable();
        self.ninetyDaySupplyAvailable = ko.observable();
        self.ePerscriptAvailable = ko.observable();
        self.providesDeliveryService = ko.observable();
        self.hasDriveThrough = ko.observable();

        self.pharmacyTypes = ko.observableArray([]);
        self.languages = ko.observableArray([]);

        // for typeahead
        self.suggestions = ko.observableArray([]);

        // ************************************************************************
        // OBSERVABLE ARRAYS ******************************************************
        // dropdown/checkbox options
        self.yearOptions = ko.observableArray(window.scan.aepYears);
        self.radiusOptions = ko.observableArray(utility.mapFacets(window.scan.emptyRadiusOptions));
        self.pharmacyTypeOptions = ko.observableArray([]);
        self.pharmacyDetailOptions = ko.observableArray([]);

        self.preferredPharmaciesOption = ko.observable();
        self.open24HoursOption = ko.observable();
        self.ninetyDaySupplyAvailableOption = ko.observable();
        self.providesDeliveryServiceOption = ko.observable();
        self.hasDriveThroughOption = ko.observable();
        self.spokenlanguageOptions = ko.observableArray([]);

        // usedNonDefaultParams = utility.initializeFilters(self, urlParams, defaultParameters);

        function getDetailsByString(locatorString) {
            return self.pharmacyDetailOptions().filter(function (item) {
                return item.name === locatorString;
            })[0];
        }

        function removeCount(str) {
            return str.slice(0, str.lastIndexOf("("));
        }

        // loading status
        self.loadingResults = ko.observable(false);
        self.loadingFacets = ko.observable(false);
        self.displayRequiredFieldError = ko.observable(false);

        self.totalResults = ko.observable(0);
        self.results = ko.observableArray();
        self.pageList = ko.observableArray([]);

        // if (urlParams.planState != undefined && urlParams.planState != "") {
        //     window.scan.stateValueDefault = urlParams.planState[0];
        // }

        //select plans
        self.isConnectionsPharmacy = ko.observable();
        self.planState = ko.observable(urlParams.planState || window.scan.stateValueDefault);
        self.planStateStaged = ko.observable();
        self.planStateOptions = ko.observableArray(window.scan.pharmacyStates);
        self.planCounty = ko.observable(urlParams.planCounty);
        self.showCountyErrorMessage = ko.observable(false);
        self.planCountyStaged = ko.observable("");
        self.planCountyOptions = ko.observableArray([]);
        self.planSelected = ko.observable();
        self.planSelectedStaged = ko.observable();

        self.planSelectedName = ko.observable(urlParams.planSelectedName || defaultPlanName);
        self.planSelectOptions = ko.observableArray("");
        self.planSelectedNameIsDefault = ko.computed(function () {
            return self.planSelectedName() === defaultParameters.planSelectedName;
        });

        if (urlParams.scan_state) {
            self.planState(urlParams.scan_state);
            urlParams.planState = urlParams.scan_state;
        }

        self.isViewAllFilterCollapsed = ko.observable(false);

        self.allFilterCallapsed = function (ele) {
            self.isViewAllFilterCollapsed(ele);
        };

        self.hasPlanSelected = ko.computed(function () {
            return self.planSelected() !== undefined;
        });

        self.selectStagedPlan = function (hideOverlay = false) {
            if (self.planState() !== self.planStateStaged()) {
                self.planState(self.planStateStaged());
            }
            if (self.planCountyStaged() && self.planCounty() !== self.planCountyStaged()) {
                self.planCounty(self.planCountyStaged());
            }
            if (self.planSelectedStaged() && self.planSelectedStaged().Value && self.planSelected() !== self.planSelectedStaged()) {
                self.setSelectedPlanByValue("planSelected", self.planSelectedStaged().Value);
            }

            self.toggleShowPlansOverlay(self, null, hideOverlay);

            if (!self.zipOrAddress() && !self.name()) {
                geoLocateZipcode();
            } else {
                // retrieve the full set of results
                const maxPage = self.pageNumber();
                const initialPageSize = pageSize;

                if (maxPage > 1) {
                    self.pageSize(maxPage * initialPageSize);
                }

                self.beginSearch();
                self.pageSize(initialPageSize);
                self.pageNumber(maxPage);
            }
        };

        self.year.subscribe(function () {
            if (urlParams.planState != undefined && urlParams.planState != "") {
                if (!$.isArray(urlParams.planState)) {
                    window.scan.stateValueDefault = urlParams.planState;
                }
                else {
                    window.scan.stateValueDefault = urlParams.planState[0];
                }
            }
            self.planStateStaged(window.scan.stateValueDefault);
            self.planCountyStaged("");
        });

        let oldStateValue;
        self.planStateStaged.subscribe(function (newVal) {
            if ((initialLoad && !newVal) || (oldStateValue && oldStateValue === newVal)) {
                return false;
            }

            if (newVal === undefined || newVal === "") {
                // reset planCountyOptions
                self.planCountyOptions([]);
                return false;
            }

            const parameters = {
                state: self.planStateStaged(),
                year: self.year()
            };

            self.pharmacyService.getCounties(parameters, false).done(function (results) {
                try {
                    const planState = self.planStateStaged();
                    if (results && results.length > 0) {
                        self.planCountyOptions(results);
                        if (urlParams.planCounty) {
                            self.planCountyStaged(urlParams.planCounty);
                        }
                    } else {
                        if (planState && planState !== "") {
                            // empty out county options
                            self.planCountyOptions([]);
                            self.showCountyErrorMessage(true);
                        }
                    }
                } catch (e) {
                    log(e.message);
                    self.isSearchStarted(false);
                }
            });
        });
        self.planStateStaged.subscribe(
            function (oldValue) {
                oldStateValue = oldValue;
            },
            null,
            "beforeChange"
        );
        self.planCountyStaged.subscribe(function (newVal) {
            if (initialLoad) {
                return false;
            }
            if (newVal === undefined || newVal === "") {
                // reset planSelectedOptions
                self.planSelectOptions([]);
                return false;
            }
            const parameters = {
                state: self.planStateStaged(),
                county: self.planCountyStaged(),
                year: self.year()
            };

            self.pharmacyService.getPlans(parameters, false).done(function (results) {
                try {
                    if (results && results.length > 0) {
                        self.planSelectOptions(results);
                        if (urlParams.planSelectedName) {
                            self.setSelectedPlanByName("planSelected", urlParams.planSelectedName);
                            if (self.planSelected() !== {}) {
                                self.planSelectedStaged(self.planSelected());
                            }
                        }
                    }
                } catch (e) {
                    log(e.message);
                    self.isSearchStarted(false);
                }
            });
        });
        self.planSelected.subscribe(function (itemObject) {
            // console.log("self.planSelected.subscribe");
            // console.log(itemObject);
            self.planSelectedName(itemObject ? itemObject.Text : defaultPlanName);
            self.isConnectionsPharmacy(itemObject ? itemObject.IsConnections : false);
        });
        self.planSelectedStaged.subscribe(function (itemObject) {
            // console.log("self.planSelectedStaged.subscribe");
            // console.log(itemObject);
            if (itemObject === {}) {
                console.log("planSelectedStaged is undefined");
            }
        });

        // ==============================================================================================
        // ==============================================================================================
        // SETTING year/state/county/plans MODAL VALUES ON PAGE LOAD
        // after subscriptions are set, set staged and actual values on page load
        setTimeout(function () {
            initialLoad = true;
            if (self.planState() && self.planCounty()) {
                const stateCountyPlans = window.scan.stateCountyPlans || {};
                const stateCountyOptions = window.scan.stateCounties;
                self.planCountyOptions(stateCountyOptions);
                self.planStateStaged(self.planState());
                self.planCountyStaged(self.planCounty());
                const currentPlanList = stateCountyPlans[self.planCounty()];
                if (currentPlanList != undefined && currentPlanList.length > 0) {
                    self.planSelectOptions(currentPlanList);
                    if (self.planSelectedName() && self.planSelectedName() !== defaultPlanName) {
                        self.setSelectedPlanByName("planSelected", self.planSelectedName());
                        if (self.planSelected() !== {}) {
                            self.planSelectedStaged(self.planSelected());
                        }
                    }
                }
            } else {
                // if planState is set (will always be), then set planStateStaged
                if (self.planState()) {
                    self.planStateStaged(self.planState());
                }
            }
            initialLoad = false;
        }, 500);
        // ==============================================================================================
        // ==============================================================================================

        self.showPlansOverlay = ko.observable(false);

        // ************************************************************************
        // Overlay ****************************************************************
        // Language Popup text filter
        self.languageFilter = ko.observable("");
        self.languagesTempNew = ko.observableArray([]);
        self.languagesTempOptions = ko.observableArray([]);
        self.languages.subscribe(function () {
            self.languagesTempNew(JSON.parse(JSON.stringify(self.languages())));
        });
        self.spokenlanguageOptions.subscribe(function () {
            self.languagesTempOptions(self.spokenlanguageOptions());
        });
        self.languagesTempOptionsFiltered = ko.computed(function () {
            return this.languagesTempOptions().filter(function (language) {
                if (!self.languageFilter() || language.name.toLowerCase().indexOf(self.languageFilter().toLowerCase()) !== -1) return language;
            });
        }, this);
        self.clearLanguages = function () {
            self.languagesTempNew([]);
        };
        self.languagesTempNewClear = function () {
            self.languagesTempNew(JSON.parse(JSON.stringify(self.languages())));
            self.languageFilter("");
        };
        self.languagesMakeTempReal = function (data, event) {
            self.languages(JSON.parse(JSON.stringify(self.languagesTempNew())));
            self.languageFilter("");
        };
        // ************************************************************************

        self.zipOrAddress.subscribe(function (value) {
            if (!value) {
                self.radiusOptions(utility.mapFacets(window.scan.emptyRadiusOptions));
                self.isSearchStarted(false);
            }
        });

        const primaryFilters = {
            sort: self.sort,
            zipOrAddress: self.zipOrAddress,
            radius: self.radius,
            name: self.name,
            year: self.year,
            preferredPharmacies: self.preferredPharmacies,
            open24Hours: self.open24Hours,
            ninetyDaySupplyAvailable: self.ninetyDaySupplyAvailable,
            ePerscriptAvailable: self.ePerscriptAvailable,
            providesDeliveryService: self.providesDeliveryService,
            hasDriveThrough: self.hasDriveThrough,
            pharmacyTypes: self.pharmacyTypes,
            languages: self.languages,
            isConnectionsPharmacy: self.isConnectionsPharmacy,
            planState: self.planState,
            planCounty: self.planCounty,
            planSelectedName: self.planSelectedName
        };

        // this is a computed that will change whenever the user actually changes
        // any of the filters that appear on the page.
        self.filters = ko.computed(function () {
            focusedElement = document.activeElement;

            // if we don't have a year, all other filters should be cleared.
            if (!self.year()) {
                self.isSearchStarted(false);
                utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            }

            return {
                sort: self.sort(),
                zipOrAddress: self.zipOrAddress(),
                radius: self.radius(),
                name: self.name(),
                year: self.year(),
                preferredPharmacies: self.preferredPharmacies(),
                open24Hours: self.open24Hours(),
                ninetyDaySupplyAvailable: self.ninetyDaySupplyAvailable(),
                ePerscriptAvailable: self.ePerscriptAvailable(),
                providesDeliveryService: self.providesDeliveryService(),
                hasDriveThrough: self.hasDriveThrough(),
                pharmacyTypes: self.pharmacyTypes(),
                languages: self.languages(),
                isConnectionsPharmacy: self.isConnectionsPharmacy(),
                planState: self.planState(),
                planCounty: self.planCounty(),
                planSelectedName: self.planSelectedName()
            };
        });

        self.filters.subscribe(function (result) {
            if (isSystemResettingFilters) {
                return false;
            }
            self.detailId(null);
            self.pageNumber(1);
            self.results([]);
            self.totalResults(0);
            self.displayRequiredFieldError(false);
            self.fatalError(false);
            tempResults = [];
        });

        self.urlParameters = ko.computed(function () {
            var filters = self.filters();

            return {
                year: filters.year,
                zipOrAddress: filters.zipOrAddress,
                radius: filters.radius,
                name: filters.name,
                preferredPharmacies: filters.preferredPharmacies,
                open24Hours: filters.open24Hours,
                ninetyDaySupplyAvailable: filters.ninetyDaySupplyAvailable,
                ePerscriptAvailable: filters.ePerscriptAvailable,
                providesDeliveryService: filters.providesDeliveryService,
                hasDriveThrough: filters.hasDriveThrough,
                pharmacyTypes: filters.pharmacyTypes,
                languages: filters.languages,
                sort: filters.sort,
                pageNumber: self.pageNumber(),
                suggestionsOnly: false,
                detailId: self.detailId(),
                path: path,
                isConnectionsPharmacy: filters.isConnectionsPharmacy,
                planState: filters.planState,
                planCounty: filters.planCounty,
                planSelectedName: filters.planSelectedName
            };
        });
        self.urlParameters.subscribe(function (params) {
            urlParameters.write(params, defaultParameters);
        });

        // this combines the currently selected values into a parameters object
        // for passing to our facets/results services.
        self.searchParameters = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                zipOrAddress: filters.zipOrAddress,
                radius: filters.radius,
                name: filters.name,
                year: filters.year,
                preferredPharmacies: filters.preferredPharmacies,
                open24Hours: filters.open24Hours,
                has90DaySupply: filters.ninetyDaySupplyAvailable,
                hasEPrescribing: filters.ePerscriptAvailable,
                providesDeliveryService: filters.providesDeliveryService,
                hasDriveThrough: filters.hasDriveThrough,
                pharmacyType: filters.pharmacyTypes,
                languages: filters.languages,
                sort: filters.sort,
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize(),
                suggestionsOnly: false,
                isConnectionsPharmacy: filters.isConnectionsPharmacy,
                planState: filters.planState,
                planCounty: filters.planCounty
            };
        });
        self.searchParametersTypeahead = ko.computed(function () {
            var filters = self.filters();

            if (!initialLoad) {
                self.detailId("");
            }

            return {
                zipOrAddress: filters.zipOrAddress,
                radius: filters.radius,
                name: filters.name,
                year: filters.year,
                preferredPharmacies: filters.preferredPharmacies,
                open24Hours: filters.open24Hours,
                has90DaySupply: filters.ninetyDaySupplyAvailable,
                hasEPrescribing: filters.ePerscriptAvailable,
                providesDeliveryService: filters.providesDeliveryService,
                hasDriveThrough: filters.hasDriveThrough,
                pharmacyType: filters.pharmacyTypes,
                languages: filters.languages,
                // typeahead sort should always be by name
                sort: "name",
                pageNumber: self.pageNumber(),
                pageSize: self.pageSize(),
                suggestionsOnly: false,
                isConnectionsPharmacy: filters.isConnectionsPharmacy
            };
        });

        isSystemResettingFilters = true;

        utility.initializeFilters(self, urlParams, defaultParameters);
        isSystemResettingFilters = false;

        // self.searchParameters.subscribe(loadFacets);

        self.hasMore = ko.computed(function () {
            if (!self.totalResults()) {
                return false;
            }
            return self.pageSize() * self.pageNumber() < self.totalResults();
        });

        // this id will be used to keep track of the latest search that we performed.
        // we will throw out any search results that were not for the latest ID.
        // this helps address the scenario where the user is rapidly changing filters
        // and triggering multiple searches.
        // we only want to display results for the last set of search parameters.
        var lastSearchRequestId = 1;

        var executeSearch = function () {
            if (!self.isAnyRequiredFieldPopulated()) {
                self.isSearchStarted(false);
                return;
            }

            // set isSearchStarted to show spinner
            self.isSearchStarted(true);

            var id = ++lastSearchRequestId;

            self.loadingResults(true);
            self.loadingFacets(true);
            self.fatalError(false);

            var parameters = self.searchParameters();

            gtmDataLayerPush(parameters, defaultParameters);

            self.pharmacyService
                .getResults(parameters, false)
                .done(function (results) {
                    try {
                        if (id !== lastSearchRequestId) {
                            // ignore any search results that come back for previous searches
                            return;
                        }

                        console.log(">>>>>>>>>> executeSearch returned " + results.CurrentResults.length + " results @ " + new Date());

                        self.results([]); // clear out results from previous page
                        tempResults = tempResults.concat(results.CurrentResults);

                        for (var i in results.CurrentResults) {
                            if (results.CurrentResults.hasOwnProperty(i)) {
                                self.results.push(new PharmacyResultViewModel(self, results.CurrentResults[i], results.latitude, results.longitude, parameters.year, parameters.radius));
                            }
                        }
                        self.currentSearchParameters(parameters);
                        self.pharmacyTypeOptions(results.Facets.PharmacyType.sort(utility.sortDescendingByCount));
                        self.spokenlanguageOptions(results.Facets.Language.sort(utility.sortDescendingByCount));
                        if (results.Facets.PharmacyDetails) {
                            self.pharmacyDetailOptions(results.Facets.PharmacyDetails);
                            self.preferredPharmaciesOption(removeCount(getDetailsByString("preferredPharmacies").text));
                            self.open24HoursOption(removeCount(getDetailsByString("open24Hours").text));

                            if (getDetailsByString("has90DaySupply")) {
                                self.ninetyDaySupplyAvailableOption(removeCount(getDetailsByString("has90DaySupply").text));
                            }
                            if (getDetailsByString("has100DaySupply")) {
                                self.ninetyDaySupplyAvailableOption(removeCount(getDetailsByString("has100DaySupply").text));
                            }

                            self.providesDeliveryServiceOption(removeCount(getDetailsByString("providesDeliveryService").text));
                            self.hasDriveThroughOption(removeCount(getDetailsByString("hasDriveThrough").text));

                            self.hasSearchRun(true);
                        } else {
                            self.hasSearchRun(false);
                        }
                        self.radiusOptions(results.Facets.Radius);
                        self.totalResults(results.TotalResults);

                        self.loadingResults(false);
                        self.isSearchStarted(false);

                        utility.recalculatePageNumbers(self);

                        if ($(focusedElement).attr("name")) {
                            setTimeout(function () {
                                $("#" + $(focusedElement).attr("id")).focus();
                            }, 100);
                        }

                        if (self.year._state.latestValue >= 2021) {
                            $(".daySupply100").show();
                            $(".daySupply90").hide();
                        } else {
                            $(".daySupply100").hide();
                            $(".daySupply90").show();
                        }
                    } catch (e) {
                        log(e.message);
                        self.isSearchStarted(false);
                    }
                })
                .fail(function () {
                    if (id !== lastSearchRequestId) {
                        // ignore any search results that come back for previous searches
                        return;
                    }

                    self.fatalError(true);
                    self.loadingResults(false);
                    self.loadingFacets(false);
                    self.isSearchStarted(false);
                });
        };

        self.searchParameters.subscribe(function () {
            if (isSystemResettingFilters) {
                return false;
            }
            // set isSearchStarted to show spinner
            self.isSearchStarted(true);
            tempResults = [];
            executeSearch();
        });

        // status indicators
        self.pages = ko.computed(function () {
            return Math.ceil(self.totalResults() / self.pageSize());
        });
        self.isAEP = ko.computed(function () {
            return self.yearOptions() && self.yearOptions().length > 1;
        });

        self.isAnyRequiredFieldPopulated = function () {
            return (self.zipOrAddress() && self.zipOrAddress().length >= 5) || (self.name() && self.name().length >= 3);
        };

        self.hasConnections = function () {
            return self.isConnectionsPharmacy;
        };

        self.arePrimaryFiltersEnabled = ko.computed(function () {
            return !self.isAEP() || self.year();
        });

        self.setSelectedPlanByName = function (observable, nameToMatch) {
            ko.utils.arrayForEach(self.planSelectOptions(), function (item) {
                if (item.Text === nameToMatch) {
                    self[observable](item);
                }
            });
        };
        self.setSelectedPlanByValue = function (observable, nameToMatch) {
            ko.utils.arrayForEach(self.planSelectOptions(), function (item) {
                if (item.Value === nameToMatch) {
                    self[observable](item);
                }
            });
        };

        self.toggleShowPlansOverlay = function (vm, event, forceCloseOverlay = false) {
            if (forceCloseOverlay) {
                self.showPlansOverlay(forceCloseOverlay);
            }

            self.showPlansOverlay(!self.showPlansOverlay());

            if (!forceCloseOverlay) {
                focusedElement = document.activeElement;
                if (focusedElement) {
                    if (self.showPlansOverlay()) {
                        plansFocusTrap("#plansOverlay");
                    } else {
                        self.setFocusOnPlanOpener(".planOverlayOpener");
                    }
                }
            }
        };

        self.setFocusOnPlanOpener = function (selector) {
            if (!selector) {
                return false;
            }
            setTimeout(function () {
                const $resultsContainer = $(selector);
                $resultsContainer.focus();
            }, 500);
        };

        const plansFocusTrap = function (selector) {
            var makeKeydownListener = function (element) {
                var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                var firstFocusableEl = focusableEls[0];
                var lastFocusableEl = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')[
                    element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').length - 1
                ];
                var KEYCODE_TAB = 9;

                return function (e) {
                    var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

                    if (!isTabPressed) {
                        return;
                    }

                    if (e.shiftKey) {
                        /* shift + tab */
                        if (document.activeElement === firstFocusableEl) {
                            lastFocusableEl.focus();
                            e.preventDefault();
                        }
                    } /* tab */ else {
                        if (document.activeElement === lastFocusableEl) {
                            firstFocusableEl.focus();
                            e.preventDefault();
                        }
                    }
                };
            };

            var _listener;

            function trapFocus(element) {
                _listener = makeKeydownListener(element);
                element.addEventListener("keydown", _listener);
            }

            setTimeout(function () {
                $(selector + " .btn.cancel").focus();
                trapFocus($(selector)[0]);
            }, 500);
        };

        var clearFacetOptions = function () {
            // console.log("clearFacetOptions");
            self.pharmacyTypeOptions([]);
            self.spokenlanguageOptions([]);
            self.pharmacyDetailOptions([]);
            self.planState("");
            // self.planCountyOptions([]);
            self.planSelectOptions([]);
            self.planSelected("");
            self.showCountyErrorMessage(false);
        };

        // clear filter functions

        self.resetFilters = function () {
            isSystemResettingFilters = true;

            self.hasSearchRun(false);
            self.detailId(null);
            tempResults = [];
            self.results([]);
            self.totalResults(0);

            clearFacetOptions();
            // do not reset the previously selected year
            if (self.year() != undefined && self.year() != "") {
                defaultParameters.year = self.year();
            }
            utility.resetFiltersToDefaults(primaryFilters, defaultParameters);
            isSystemResettingFilters = false;

            self.planSelected(undefined);
            self.planSelectedStaged(undefined);
            self.planCountyStaged(undefined);
        };

        self.beginSearch = function () {
            self.fatalError(false);
            if (self.isAnyRequiredFieldPopulated()) {
                tempResults = [];
                self.currentSearchParameters(null);
                executeSearch(true);
            } else {
                self.displayRequiredFieldError(true);
                self.isSearchStarted(false);
            }
        };

        self.setFocusOnResults = function () {
            utility.setFocusOnResults();
        };
        self.loadPrev = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) - 1);
            utility.setFocusOnResults();
        };
        self.loadNext = function () {
            self.pageNumber(parseInt(self.pageNumber(), 10) + 1);
            utility.setFocusOnResults();
        };
        self.setPage = function (pageObject) {
            utility.setPageNumber(self, pageObject);
        };
        self.setLastPage = function () {
            self.pageNumber(parseInt(self.pages(), 10));
            utility.setFocusOnResults();
        };

        self.viewDetails = function (providerId, lat, lng) {
            // console.log("set cache for " + providerId);
            //console.table(tempResults);
            if (tempResults.length !== self.totalResults()) {
                console.error("mismatch tempResults vs totalReslts");
            }

            self.isLeavingForDetailPage(true);
            self.detailId(providerId);

            var query = {
                // required
                providerId: providerId,
                latitude: lat,
                longitude: lng,
                radius: self.radius(),
                year: self.year(),

                // for future use
                ZipOrAddress: self.zipOrAddress(),
                Name: self.name(),
                PharmacyType: self.pharmacyTypes(),
                Languages: self.languages(),
                Open24Hours: self.open24Hours(),
                ProvidesDeliveryService: self.providesDeliveryService(),
                HasDriveThrough: self.hasDriveThrough(),
                PreferredPharmacies: self.preferredPharmacies(),
                Has90DaySupply: self.ninetyDaySupplyAvailable(),
                HasEPrescribing: self.ePerscriptAvailable(),
                IsConnectionsPharmacy: self.isConnectionsPharmacy(),

                // pass through URL params
                Return_URL: returnUrl,
                path: path
            };

            query = urlParameters.reduceParams(query, {});

            window.location.href = window.scan.toolDetailUrl + "?" + queryString.stringify(query);
        };

        self.pdfUrl = ko.computed(function () {
            var params = self.currentSearchParameters();

            if (!params) {
                return null;
            }

            var filteredParams = urlParameters.reduceParams(params, defaultParameters, false);

            if (self.isAEP()) {
                filteredParams.year = self.year();
            }

            filteredParams.contextItemId = self.contextItemId();
            filteredParams.radius = self.radius();
            filteredParams.pageNumber = self.pageNumber();
            filteredParams.pageSize = self.pageSize();

            return "/controller/PharmacySearchPdf/Download?" + queryString.stringify(filteredParams);
        });

        self.emailUrl = ko.computed(function () {
            var urlParts = window.location.href.split("/");

            var domain = urlParts[0] + "//" + urlParts[2],
                downloadLink = domain + self.pdfUrl(),
                subject = encodeURIComponent("Your SCAN Search"),
                body = encodeURIComponent("Download your PDF here: " + downloadLink),
                emailUrl = "mailto:?subject=" + subject + "&body=" + body;

            return emailUrl;
        });

        self.clickOpen24HoursOnly = function (model, event) {
            self.open24Hours(!self.open24Hours());
            event.preventDefault();
            return false;
        };

        self.clickPreferredOnly = function (model, event) {
            self.preferredPharmacies(!self.preferredPharmacies());
            event.preventDefault();
            return false;
        };

        self.clickProvidesDeliveryService = function (model, event) {
            self.providesDeliveryService(!self.providesDeliveryService());
            event.preventDefault();
            return false;
        };

        self.clickHasDriveThrough = function (model, event) {
            self.hasDriveThrough(!self.hasDriveThrough());
            event.preventDefault();
            return false;
        };

        function geoLocateZipcode() {
            // use current location to get results
            try {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            var latitude = position.coords.latitude;
                            var longitude = position.coords.longitude;

                            // chrome dev tools allows you to set geo sensor to 33.8071979, -118.1444659 (SCAN HQ)
                            geocoder.geodecode(latitude, longitude).then(function (result) {
                                self.zipOrAddress(result.zipcode); // this kicks off a filter update
                            });
                        },
                        function () {
                            console.log("user declined geolocation");
                        }
                    );
                }
            } catch (e) {
                console.log(e.message);
            }
        }

        //if (!self.zipOrAddress() && !self.name()) {
        //    geoLocateZipcode();
        //} else {
        //    // retrieve the full set of results
        //    var maxPage = self.pageNumber();
        //    var initialPageSize = pageSize;

        //    if (maxPage > 1) {
        //        self.pageSize(maxPage * initialPageSize);
        //    }

        //    self.beginSearch();
        //    self.pageSize(initialPageSize);
        //    self.pageNumber(maxPage);
        //}
        initialLoad = false;
    };
});
